module.exports = __webpack_public_path__ + "static/city-bottom-fa561cf8001a17fcf6207bd483657088.png";